import React from 'react';
import ReactDOM from 'react-dom/client';

import { env } from '~/lib/env';
import { startMonitoring } from '~/modules/monitoring/startMonitoring';

import { App } from './App';

startMonitoring();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App localBrand={env('VITE_BRAND', false)} />
  </React.StrictMode>,
);
